



















import { Component, Vue } from 'vue-property-decorator'
import request, { Response } from '@/helpers/requests'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


interface SmcSettings {
    autoApprove: 0|1;
    autoPost: 0|1;
    postFrequency: number;
}


interface RequestPayload extends SmcSettings {
    pulsemAccountId: number;
}


interface ResponsePayload extends Response {
    data: {
        settings: SmcSettings;
        settingsExist: boolean;
    };
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class SocialMediaCurationSettings extends Vue {
    locationValid = false
    pulsemAccountId: number|null = null
    settingsExist: boolean|null = null
    autoApprove: 0|1|null = null
    autoPost: 0|1|null = null
    postFrequency: string|null = null

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId as number,
            autoApprove: this.autoApprove ? 1 : 0,
            autoPost: this.autoPost ? 1 : 0,
            postFrequency: parseInt(this.postFrequency as string)
        }
    }

    async loadSettings(): Promise<ResponsePayload> {
        return await request.post('/support/smc-settings-load', {
            pulsemAccountId: this.pulsemAccountId
        }) as ResponsePayload
    }

    async onLocationChange(locationValid: boolean) {
        this.locationValid = locationValid
        if (this.locationValid) {
            const response = await this.loadSettings()
            this.autoApprove = response.data.settings.autoApprove
            this.autoPost = response.data.settings.autoPost
            this.postFrequency = String(response.data.settings.postFrequency)
            this.settingsExist = response.data.settingsExist
        } else {
            this.autoApprove = null
            this.autoPost = null
            this.postFrequency = null
            this.settingsExist = null
        }
    }

    onSuccess(status: boolean) {
        if (status) {
            this.pulsemAccountId = null
            this.locationValid = false
            this.autoApprove = null
            this.autoPost = null
            this.postFrequency = null
            this.settingsExist = null
        }
    }
}
